import { SET_CURRENT_USER, SET_LANG, UPDATE_CURRENT_USER, SET_ADDRESS, SET_PAYMENT, SHOW_BRANDS } from "./user.type";

const INITIAL_STATE = {
    currentUser : null,
    currentAddress : null , 
    currentPayment : null , 
    brandList : [], 
}
const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state,
                currentUser : action.payload
            }
        case SHOW_BRANDS:
            return {
                ...state,
                brandList : action.payload
            }
        case UPDATE_CURRENT_USER:
            return {
                ...state,
                currentUser : {...state.currentUser,  ...action.payload}
            }
        case SET_LANG:
            return {
                ...state,
                currentLang : action.payload 
            }
        case SET_ADDRESS:
            return {
                ...state, 
                currentAddress : action.payload 
            }
        case SET_PAYMENT:
            return {
                ...state, 
                currentPayment : action.payload 
            } 
    
        default:
            return state;
    }
}

export default userReducer;